import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "stopwatch_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 1H8v2h2.5v1.124a9 9 0 1 0 3 0V3H16V1ZM4.5 3 2 5.5 3.5 7 6 4.5 4.5 3Zm13.156 5.758-1.414-1.414-5.9 5.9 1.415 1.414 5.9-5.9Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }